import type { ModelViewerHandle } from '../components/scene/ModelViewer';

const registry = new Map<string, ModelViewerHandle>();

export const modelRefsRegistry = {
  set(id: string, handle: ModelViewerHandle) {
    registry.set(id, handle);
  },
  delete(id: string) {
    registry.delete(id);
  },
  get(id: string) {
    return registry.get(id) ?? null;
  },
  getAll() {
    return registry;
  },
};
